import React, { useState, useEffect } from 'react';
import './CustomAlert.css';

const CustomAlert = ({ alert, onClose }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (alert) {
      setIsVisible(true);
      
      // persistent가 true인 경우 자동으로 닫히지 않음
      if (!alert.persistent) {
        // 자동으로 사라지게 하기 (success/info는 1초, error는 3초)
      const timer = setTimeout(() => {
        handleClose();
        }, alert.type === 'error' ? 3000 : 1000);

      return () => clearTimeout(timer);
      }
    }
  }, [alert]);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => {
      onClose();
    }, 300); // 애니메이션 완료 후 제거
  };

  if (!alert) return null;

  const getIcon = () => {
    switch (alert.type) {
      case 'success':
        return '✅';
      case 'error':
        return '❌';
      case 'warning':
        return '⚠️';
      case 'info':
      default:
        return 'ℹ️';
    }
  };

  return (
    <div className={`custom-alert-overlay ${isVisible ? 'visible' : ''}`}>
      <div className={`custom-alert ${alert.type} ${isVisible ? 'show' : ''}`}>
        <div className="alert-header">
          <span className="alert-icon">{getIcon()}</span>
          <button className="alert-close" onClick={handleClose}>×</button>
        </div>
        <div className="alert-content">
          {alert.title && <h4 className="alert-title">{alert.title}</h4>}
          <p className="alert-message">{alert.message}</p>
        </div>
        {alert.actions && (
          <div className="alert-actions">
            {alert.actions.map((action, index) => (
              <button
                key={index}
                className={`btn ${action.style || 'btn-primary'}`}
                onClick={() => {
                  action.onClick();
                  handleClose();
                }}
              >
                {action.label}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomAlert; 